import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Book, Home, Users, ShoppingCart } from "lucide-react";
import UserMenu from "./UserMenu";

const Layout = () => {
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "Dashboard", icon: Home },
    { to: "/clients", label: "Klienci", icon: Users },
    { to: "/orders", label: "Zamowienia", icon: ShoppingCart },
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans">
      <nav className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between shadow-sm sticky top-0 z-50">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold text-indigo-600">
          <Book className="w-6 h-6" />
          <span>StoryBook</span>
        </Link>
        <div className="flex items-center gap-4">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium flex items-center gap-1 transition-colors ${
                  isActive ? "text-indigo-600" : "text-slate-600 hover:text-indigo-600"
                }`}
              >
                <link.icon className="w-4 h-4" /> {link.label}
              </Link>
            );
          })}
          <div className="w-px h-6 bg-slate-200" />
          <UserMenu />
        </div>
      </nav>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
